// Largest valid start index so the last page is always full.
export const getMaxStart = (total, visibleCount) =>
  Math.max(0, total - visibleCount);

export const clampStart = (start, total, visibleCount) =>
  Math.min(Math.max(0, start), getMaxStart(total, visibleCount));

export const getVisibleItems = (items, start, visibleCount) =>
  items.slice(start, start + visibleCount);
